import React, { useState } from 'react'
import '../../Styles/AdditionalPages/Contact.css'

export default function Contact() {
  const [name, setname] = useState('');
  const [email, setemail] = useState('');
  const [query, setquery] = useState('');
  const [desc, setdesc] = useState('');
  
  const contactusformsubmithandler = async (e)=>{
    e.preventDefault();
    const res = await fetch( 
      "https://mdcollege-82d65-default-rtdb.firebaseio.com/Peopledata.json", 
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          query,
          desc,
        }),
      }
      );

      if(res) alert("Data Stored");
      else alert("Error");
    

    setname(''); setemail(''); setquery(''); setdesc('');
  }
  return (
    <div className='contactus'>
      <div className="contactuscontainer">
        <div className="contactussec1">
          <h1 className="contactushead">ASK YOUR QUERY</h1>
          <form method="POST" className='contactusform' autoComplete='off'>
            <label htmlFor="name">Name </label>
            <input type="text" name="name" id="name" value={name} onChange={e=>{setname(e.target.value)}} required/>
            <label htmlFor="email">Email </label>
            <input type="email" name="email" id="email" value={email} onChange={e=>{setemail(e.target.value)}} required/>
            <label htmlFor="query">Query</label>
            <input type="text" name="query" id="query" value={query} onChange={e=>{setquery(e.target.value)}} required/>
            <label htmlFor="desc">Description</label>
            <textarea placeholder='Please provide a brief description of your query . . .' name="desc" id="desc" rows={3} value={desc} onChange={e=>{setdesc(e.target.value)}}></textarea>
            <button className='contactusbutton' onClick={contactusformsubmithandler}>SUBMIT</button>
          </form>
        </div>

        <div className="contactussec2">
          <h1 className="contactushead">ADDRESS</h1>
          <p className="contactussec2para">ग्राम बडूली, कोल्की रेलवे ओवर ब्रिज ( गागलहेडी से 6 किमी. ) मुजफ्फरनगर रोड जिला सहारनपुर - 247001</p>
          <iframe className='map contactusmap' src="https://www.google.com/maps/embed/v1/place?q=Maharishi+Dayanand+Inter+College,+Navin+Nagar,+Saharanpur,+Uttar+Pradesh,+India&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8" title='Our office' loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>

        <div className="contactussec3">
          <h1 className="contactushead">FEEL FREE TO CALL</h1>
          <p className="contactussec3num">Helpline Numbers :</p>
          <div className="contactussec3numbers">
            <a href="tel:+919627793555"><i className="contacticon fa-solid fa-phone"></i>91-9627793555</a>
            <a href="tel:+919355789786"><i className="contacticon fa-solid fa-phone"></i>91-9355789786</a>
            <a href="tel:+919627793111"><i className="contacticon fa-solid fa-phone"></i>91-9627793111</a>
            <a href="tel:+919627793222"><i className="contacticon fa-solid fa-phone"></i>91-9627793222</a>
          </div>
          <p className="contactussec3num">Email :</p>
          <div className="contactussec3numbers">
            <a className='contactusemail' href="mailto:mdcollegesaharanpur@gmail.com"><i className="contacticon fa-solid fa-envelope"></i>mdcollegesaharanpur@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
  )
}
